export const CLUSTER_SELECTION_TITLE = "Selection Information" as const;
